import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PolicyModel')
export default class PolicyModel {
  @JsonProperty('id', Number) public id:number = -1;
  @JsonProperty('max_price', Number) public maxPrice:number = undefined;
  @JsonProperty('max_price_with_breakfast', Number, true) public maxPriceWithBreakfast:number = undefined;
}
